import { gql } from '@apollo/client'

export const ADD_PLAYER_TO_MARKET = gql`
  mutation AddPlayerToMarket($fantasyLeagueId: ID!, $playerId: ID!, $price: Int!, $expiresAt: ISO8601DateTime) {
    addPlayerToMarket(input: { fantasyLeagueId: $fantasyLeagueId, playerId: $playerId, price: $price, expiresAt: $expiresAt }) {
      marketEntry {
        id
        price
        status
        listedAt
        expiresAt
        player {
          id
          nick
          role
          marketValue
          team {
            id
            competition {
              id
              code
              displayName
              rank
            }
            nameShow
            shortName
          }
        }
      }
      errors
    }
  }
`

export const PLACE_BID = gql`
  mutation PlaceBid($marketEntryId: ID!, $amount: Int!) {
    placeBid(input: { marketEntryId: $marketEntryId, amount: $amount }) {
      bid {
        id
        amount
        createdAt
        marketEntry {
          id
        }
        bidder {
          id
          user {
            id
            fullName
          }
        }
      }
      errors
    }
  }
`

export const WITHDRAW_BID = gql`
  mutation WithdrawBid($marketEntryId: ID!) {
    withdrawBid(input: { marketEntryId: $marketEntryId }) {
      success
      errors
    }
  }
`

export const UPDATE_BID_STATUS = gql`
  mutation UpdateBidStatus($bidId: ID!, $newStatus: String!) {
    updateBidStatus(input: { bidId: $bidId, newStatus: $newStatus }) {
      bid {
        id
        status
        amount
        marketEntry {
          id
          status
        }
      }
      errors
    }
  }
`

export const REMOVE_PLAYER_FROM_MARKET = gql`
  mutation RemovePlayerFromMarket($marketEntryId: ID!) {
    removePlayerFromMarket(input: { marketEntryId: $marketEntryId }) {
      success
      errors
    }
  }
`
